import * as React from "react";
import { Checkbox } from "../forms/Checkbox";
import { Avatar } from "../display/Avatar";
import { Timestamp } from "../display/Timestamp";

/**
 * Action item with owner, due date and source timestamp. Checking it strikes the text through.
 */
export interface ActionItemProps {
  text: React.ReactNode;
  owner?: { name: string; speaker?: 1 | 2 | 3 | 4 | 5 };
  due?: string;
  time?: string;
  done?: boolean;
  defaultDone?: boolean;
  onToggle?: (done: boolean) => void;
  onTimeClick?: () => void;
  /** Mobile: smaller text, avatar only, no due column */
  compact?: boolean;
  className?: string;
}

export function ActionItem({
  text,
  owner,
  due,
  time,
  done,
  defaultDone = false,
  onToggle,
  onTimeClick,
  compact,
  className,
}: ActionItemProps): JSX.Element {
  const [inner, setInner] = React.useState(defaultDone);
  const on = done === undefined ? inner : done;
  const toggle = (v: boolean) => {
    if (done === undefined) setInner(v);
    onToggle?.(v);
  };
  return (
    <div className={["gk-action", on && "gk-action--done", compact && "gk-action--compact", className].filter(Boolean).join(" ")}>
      <Checkbox checked={on} onChange={toggle} label="Done" />
      <span className="gk-action__text">{text}</span>
      {owner &&
        (compact ? (
          <Avatar name={owner.name} speaker={owner.speaker} size={24} />
        ) : (
          <span className="gk-action__owner">
            <Avatar name={owner.name} speaker={owner.speaker} size={22} />
            {owner.name.split(" ")[0]}
          </span>
        ))}
      {due && !compact && <span className="gk-action__due">{due}</span>}
      {time && !compact && <Timestamp time={time} onClick={onTimeClick} />}
    </div>
  );
}
